import type { OrgData, OrgExtra } from '../organisationFixtures';

interface PayAdviceTabProps {
  orgId: string;
  orgData: OrgData;
  orgExtra: OrgExtra | undefined;
}

const booleanToString = (value: boolean): string => value ? 'Yes' : 'No';

export const PayAdviceTab = ({ orgExtra }: PayAdviceTabProps) => {
  if (orgExtra === undefined)
    return <div className="mgo-padding-l">Loading...</div>;

  const { payAdvice } = orgExtra;

  return (
    <div className="mgo-stack mgo-gap-l">
      <dl style={{ display: 'grid', gridTemplateColumns: 'max-content 1fr', gap: 'var(--mgo-space-10) var(--mgo-space-20)', margin: 0 }}>
        <dt className="mgo-weight-strong mgo-color-muted">Template</dt>
        <dd style={{ margin: 0 }}>{payAdvice.template}</dd>
        <dt className="mgo-weight-strong mgo-color-muted">Delivery methods</dt>
        <dd style={{ margin: 0 }}>{payAdvice.delivery.join(', ')}</dd>
        <dt className="mgo-weight-strong mgo-color-muted">Show YTD</dt>
        <dd style={{ margin: 0 }}>{booleanToString(payAdvice.showYtd)}</dd>
        <dt className="mgo-weight-strong mgo-color-muted">Show leave balances</dt>
        <dd style={{ margin: 0 }}>{booleanToString(payAdvice.showLeave)}</dd>
        <dt className="mgo-weight-strong mgo-color-muted">Footer</dt>
        <dd style={{ margin: 0 }}>{payAdvice.footer}</dd>
      </dl>
    </div>
  );
};
